// extracted by mini-css-extract-plugin
module.exports = {"quoteContainer":"Quote_quoteContainer__Bhmj0","quoteFooter":"Quote_quoteFooter__VRAT8","quoteCite":"Quote_quoteCite__6NbYu"};